import { render, staticRenderFns } from "./StandardCard.component.vue?vue&type=template&id=b3f1be82&scoped=true&"
import script from "./StandardCard.component.vue?vue&type=script&lang=js&"
export * from "./StandardCard.component.vue?vue&type=script&lang=js&"
import style0 from "./StandardCard.component.vue?vue&type=style&index=0&id=b3f1be82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f1be82",
  null
  
)

export default component.exports